import React, {useState} from "react";
import QuadralButton from "@quadral/quadral-component-common/dist/components/button";
import QuadralModal from "@quadral/quadral-component-common/dist/components/modal";
import QuadralContainer from "@quadral/quadral-component-common/dist/components/container";
import QuadralTypography from "@quadral/quadral-component-common/dist/components/typography";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import {onlineProcessesService} from "../../services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { themeColors } from "../../theme/themeConstants";

export default function SendMailModal({
                                          open,
                                          setOpen,
                                          participation,
                                          quadralToast,
                                          ...props
                                      }) {

    const [paperCommunication, setPaperCommunication] = useState("false");

    async function handleConfirm() {
        props.showLoader();
        setOpen(false);

        let body = paperCommunication === "true";

        onlineProcessesService.sendMail({surveyParticipationId: participation.id}, body)
            .then(data => {
                quadralToast.success("Formulaire envoyé avec succès");
                props.hideLoader();
            })
            .catch(error => {
                console.error("Erreur lors de l'envoi du formulaire : ", error);
                quadralToast.error("Erreur lors de l'envoi du formulaire ");
                props.hideLoader();
            });

    }

    return (
        <>
            {open && (
                <QuadralModal
                    title="Envoyer le formulaire au format papier"
                    icon={<FontAwesomeIcon icon={faEnvelope}/>}
                    onClose={() => setOpen(false)}
                    open={open}
                    setOpen={setOpen}
                    noButton
                    action={<>
                        <QuadralButton label="Confirmer l'envoi au format papier" startIcon={<FontAwesomeIcon icon={faEnvelope}/>} onClick={handleConfirm}/>
                        <QuadralButton label='Annuler' color="secondary" onClick={() => setOpen(false)}/>
                    </>}
                >
                        <QuadralContainer orientation='row' sx={{paddingBottom: '10px'}}>
                            <QuadralContainer orientation='col'>
                                <QuadralTypography variant="normal">
                                    Cette action va envoyer le courrier d'invitation ainsi que le formulaire de participation à : {participation?.firstname} {participation?.lastname}
                                    <b> au format papier.</b>
                                </QuadralTypography>
                            </QuadralContainer>
                        </QuadralContainer>

                        <QuadralContainer orientation='row'>
                            <QuadralContainer orientation='col'>
                                <QuadralTypography variant="normal" sx={{fontSize: '14px'}}>
                                    <p>Êtes-vous sûr(e) de vouloir envoyer le formulaire d'enquête au format papier ?</p> 
                                    <b style={{color: themeColors.warning.main}}> Une participation au format papier coûte 5 fois plus cher</b> qu'une participation en ligne. 
                                    <p>Nous vous recommandons de <b>vous assurer auprès des participants qu'il n'y a pas d'autre solution que le papier</b> pour ce dossier avant de confirmer l’action. </p>
                                </QuadralTypography>
                            </QuadralContainer>
                        </QuadralContainer>

                        <QuadralContainer orientation='row' sx={{padding: '10px 0'}}>
                            <QuadralContainer orientation='col'>
                                <QuadralTypography variant="normal">
                                    Souhaitez-vous également que toutes les prochaines communications passent par le canal papier ?
                                </QuadralTypography>
                            </QuadralContainer>
                        </QuadralContainer>

                        <QuadralContainer orientation='row' className="c-mb-2">
                            <QuadralContainer orientation='col'>
                                <RadioGroup
                                    value={paperCommunication}
                                    onChange={(e) => setPaperCommunication(e.target.value)}
                                    col
                                >
                                    <FormControlLabel
                                        control={<Radio />}
                                        label="Oui"
                                        value="true"
                                        sx={{paddingBottom: '0.25rem'}}
                                    />
                                    <FormControlLabel
                                        control={<Radio />}
                                        label="Non"
                                        value="false"
                                    />
                                </RadioGroup>
                            </QuadralContainer>
                        </QuadralContainer>
                </QuadralModal>
            )}
        </>
    );
}